
// ========= TESTIMONIALS

var testimonials_instances = [];

var initTestimonials = function() {

	var testimonials = $('.testimonial-section');

	if ( testimonials.length ) {
		testimonials.each(function(){
			testimonials_instances.push(initTestimonialsSlider($(this)));
		})

	}
}
var destroyTestimonials = function() {
	var instance;
	while (testimonials_instances.length) {
		instance = testimonials_instances.shift();
		instance.destroy();
	}
}

var initTestimonialsSlider = function(container) {

	var testimonials = {

		initialized: false,
		container: null,
		slider: null,
		options: {
		infinite: true,
		autoplay: false,
		fade: true,
		speed: 600,
		dots: false,
		arrows: true,
		appendArrows: container.find('.slider-nav .arrow-wrapper'),
	    prevArrow: '<button type="button" class="slider-prev btn-style-none outline" alt="Go to previous slide">' + arrow_left + '</button>',
	    nextArrow: '<button type="button" class="slider-next white btn-style-none outline" alt="Go to next slide">' + arrow_right + '</button>',
        // prevArrow: '<button type="button" class="arrow-btn arrow-prev" aria-label="Previous"><i class="icon-arrow-left"></i></button>',
        // nextArrow: '<button type="button" class="arrow-btn arrow-next" aria-label="Next"><i class="icon-arrow-right"></i></button>',
		lazyLoad: 'ondemand',
		draggable: false,
		firstResize: true,
		rows: 0
		},

		draw: function(){
			var _this = this;
			_this.el =  _this.slider.slick(_this.options);
		},

		destroy: function() {
			var _this = this;
			if ( !_this.el ) return;
			_this.el.slick('unslick');
			_this.initialized = false;
		},

		// resize: function(e) {
		// 	// if in window resize event, "this" is given as param
  //   		var _this = e == null ? this : e.data.obj;

		// 	var wrapper_width = _this.slider.width();
		// 	// if ( Modernizr.mq("screen and (max-width:"+bp_tablet_landscape+"px)")) { 
		// 	// 	wrapper_width = '100%';
		// 	// }
		//     //_this.slider.find('article').css('width', wrapper_width);
		// },

		addImgSource: function(img) {
			var _this = this;

			// Mobile Image ( - 991px )
			if ( Modernizr.mq("screen and (max-width:" + bp_cmsMobile + "px)") ) {
				img.each(function () {
					$(this).attr("data-lazy",  $(this).attr('data-mobileImage'));
				});
			} 
			// Desktop image (992px + )
			else {
				img.each(function () {
					$(this).attr("data-lazy",  $(this).attr('data-fullImage'));
				});
			}
		},

		updateCount: function(index) {
			var _this = this;

			var i = ('0' + (index+1)).slice(-2);

			_this.container.find('.slider-nav .current').html(i);

		},

		resize: function(e) {
			// if in window resize event, "this" is given as param
    		var _this = e == null ? this : e.data.obj;
			
			var bg = _this.container.find('.testimonial-section-bg');

			if ( Modernizr.mq("screen and (max-width:"+bp_cmsMobile+"px)") ) { 

				// Slide Height
				// var sliderH = _this.container.outerHeight();
				// _this.container.find('.slide').css('height', sliderH);

				// Background image
				var bg_col = _this.container.find('.img-block');
				var bg_top =  _this.container.height() - bg_col.height() - 50;
				var bg_left = '';
				
			} else {

				// Background image
				var bg_col = _this.container.find('.testimonial-third-col');
				var bg_left = bg_col.offset().left + parseInt(bg_col.css('padding-left'), 10);
				var bg_top = '';
				
			}

			bg.css({
				'left': bg_left,
				'top': bg_top
			});
			bg.removeClass('loading');

			if ( _this.firstResize ) {
				// _this.container.find('.slider-loader').fadeOut();
				_this.container.removeClass('loading');
				_this.firstResize = false;
			}

		},

		reset: function() {
			var _this = this;
			_this.destroy();
			_this.draw();
		},
		init: function(container) {
			var _this = this;

			if (container === undefined || container.length < 1) return;

			_this.container = container;
			// _this.options.autoplay = container.attr('data-autoplay');
			// _this.options.appendDots = container.find('.slider-dots');
			_this.slider = _this.container.find('.testimonial-slider');


			// update lazy load source
			_this.addImgSource(_this.slider.find('.img-block'));

			// === Events
		    _this.slider.on('init', function (slick) {

				_this.resize();

			    // _this.container.find('.slider-loader').fadeOut();
				_this.initialized = true;

				// content
				_this.slider.find('.slick-slide').addClass('hide-content');
				_this.slider.find('.slick-active').removeClass('hide-content');
		    });
			_this.slider.on('beforeChange', function(event, slick, currentSlide, nextSlide) {
				// hide content before transitioning
				_this.slider.find('.slick-slide').eq(currentSlide).addClass('hide-content');

				_this.updateCount(nextSlide);
			})
			_this.slider.on('afterChange', function(event, slick, currentSlide) {

				// show content
				_this.slider.find('.slick-slide').eq(currentSlide).removeClass('hide-content');
			})

			// === Resize Background
			// _this.resize();
			
		    // === Draw slider

			//if ( !Modernizr.mq("screen and (max-width:"+bp_tablet_landscape+"px)")) { 
		    	_this.draw();
			//}

		    $(window).smartresize(function () { 
		    	_this.resize();

		    	if ( ! _this.initialized ) {
		    		_this.draw();
		    	}
		    })

			return _this;
		}
	}

	return testimonials.init(container);
	
}





// ======== CONTENT SLIDERS

var contentSlider_instances = [];

var initContentSliders = function() {
	var contentSliders = $('.content-slider-container');

	if ( contentSliders.length ) {
		contentSliders.each(function(){
			contentSlider_instances.push(initContentSlider($(this)));
		})

	}
}
var destroyContentSliders = function() {
	var instance;
	while (contentSlider_instances.length) {
		instance = contentSlider_instances.shift();
		instance.destroy();
	}
}

var initContentSlider = function (container) {

	var contentSlider = {
		initialized: false,

	    setActive: function(item) {
	        this.navItems.removeClass('active');
	        item.addClass('active');
	    },

	    addImageSource: function($img) {
    		// Mobile Image ( - 991px )
			if ( Modernizr.mq("screen and (max-width:" + bp_cmsMobile + "px)") ) {
				$img.attr("data-original",  $img.attr('data-mobileImage'));
			} 
			// Desktop image (992px + )
			else {
				$img.attr("data-original",  $img.attr('data-fullImage'));
			}
	    },

	    loadImages: function(active) {
	    	var _this = this;
	    	// load slide before and after current one;

	    	var current = _this.el.find('.slick-slide').eq(active);
	    	var before = _this.el.find('.slick-slide').eq(active-1);
	    	var after = _this.el.find('.slick-slide').eq(active+1);

	    	if (current.find('.lazy-slide-bg').css('background-image') == 'none') {
	    		var img = current.find('.lazy-slide-bg');
	    		_this.addImageSource(img);
		    	img.lazyload({
		            effect : "fadeIn",
		            load: function() {
		            	$(this).removeClass('loading');
		            }
		        });
	    	}
	    	if (before.find('.lazy-slide-bg').css('background-image') == 'none') {
	    		var img = before.find('.lazy-slide-bg');
	    		_this.addImageSource(img);
	    		img.lazyload({
		            effect : "fadeIn",
		            load: function() {
		            	$(this).removeClass('loading');
		            }
		        });
	    	}
	    	if (after.find('.lazy-slide-bg').css('background-image') == 'none') {
	    		var img = after.find('.lazy-slide-bg');
	    		_this.addImageSource(img);
	    		img.lazyload({
		            effect : "fadeIn",
		            load: function() {
		            	$(this).removeClass('loading');
		            }
		        });
	    	}	

	    	// ensure image loads

	    	$(window).scroll(); 

	    	$('html,body').animate({
		        scrollTop: $(window).scrollTop()
		    });

	    },

		draw: function(){

			var _this = this;

			// return if already init
			if ( _this.initialized ) return;

			// set first one to be active
			_this.setActive(_this.navItems.eq(0));

			// === EVENTS

		    _this.el.on('init', function (slick) {
			    _this.container.addClass('initialized');
			    _this.container.find('.slider-loader').fadeOut();

			    var active = _this.el.find('.slick-active');
			    // _this.loadImages(active.index());

				_this.initialized = true;

				// hide img-loader on active image
				// active.find('.lazy-slide-bg').removeClass('loading');
		    });

			// On Slide Change
			_this.el.on('afterChange', function(event, slick, currentSlide, nextSlide){
				// toggle active class on dots
				var active = _this.navItems.eq(currentSlide);
				_this.setActive(active);

			});
			// Before Slide Changes
			_this.el.on('beforeChange', function(event, slick, currentSlide, nextSlide){
				// toggle active class on dots
				var active = _this.navItems.eq(nextSlide);
				_this.setActive(active);

				_this.updateCount(nextSlide);

				// _this.loadImages(nextSlide);
			});

			// === SLICK CREATE SLIDER
			_this.el.slick(_this.options);
			//_this.el =  _this.slider.slick(_this.options);

			// === NAVIGATION
			_this.navItems.on('click', function(){
			// active
			_this.setActive($(this));
			// go to slide
			_this.el.slick('slickGoTo', $(this).index());
			})
		},

		destroy: function() {
			var _this = this;
			if ( _this.initialized ) {
				_this.el.slick('unslick');
				_this.container.removeClass('initialized');
				_this.initialized = false;
			}
		},

		reset: function() {
			var _this = this;
			_this.destroy();
			_this.draw();
		},

		updateCount: function(index) {
			var _this = this;

			var i = ('0' + (index+1)).slice(-2);

			_this.container.find('.count .current').html(i);

		},

		addAccordionMarkup: function() {
			var _this = this;
			// wrap slides into panel-group
			var accordionId = _this.el.attr('data-id');
			_this.el.html('');
			_this.el.html('<div class="panel-group" id="'+accordionId+'" role="tablist" aria-multiselectable="true">' + _this.markup + '</div>');


			// wrap slide body into collapsable panel
			var is_first_el = true;
			_this.el.find('.item').each(function(){
				var body = $(this).find('.slide-body');
				var id = body.attr('data-id');
				if ( is_first_el ) {
					$(this).find('.panel-title a').attr('aria-expanded', true);
					$(this).find('.panel-title a').removeClass('collapsed');
					body.wrap('<div class="collapse panel-collapse in" role="tabpanel" id="'+id+'">');
				} else {
					$(this).find('.panel-title a').addClass('collapsed');
					body.wrap('<div class="collapse panel-collapse" role="tabpanel" id="'+id+'">');
				}
				is_first_el = false;
			})
		},

		removeAccordionMarkup: function() {
			var _this = this;
			// remove panel-group div
			var markup = _this.el.find('.panel-group').html();
			_this.el.html(markup);

			// remove collapsable panel div
			var is_first_el = true;
			_this.el.find('.item').each(function(){

				// var body = $(this).find('.slide-body');
				// var markup = body.find('.panel-collapse').html();
				// body.html(markup);

				var markup = $(this).find('.panel-collapse').html();
				// _this.markup = $(this).find('.panel-collapse').html();
				$(this).find('.panel-collapse').replaceWith(markup);

				if ( is_first_el ) {
					$(this).find('.panel-title a').attr('aria-expanded', false);
					$(this).find('.panel-title a').addClass('collapsed');
				}
				is_first_el = false;
			})
		},

		init: function(container) {

			var _this = this;

			if (container.length < 1) return;

			_this.container = container;
			_this.el = _this.container.find('.content-slider .slider');
      		_this.navItems = _this.container.find('.slider-nav li');

			_this.options = {
				fade: true,
				speed: 600,
			    autoplay: false,
			    autoplaySpeed: 10000,
			    infinite: true,
			    // lazyLoad: 'ondemand', // not working with bg so do it manually
			    dots: false,
			    arrows: true,
			    rows: 0,
			    draggable:false,
			    appendArrows: _this.container.find('.slider-arrows'),
			    prevArrow: '<button type="button" class="slider-prev white btn-style-none outline" alt="Go to previous slide">' + arrow_left + '</button>',
			    nextArrow: '<button type="button" class="slider-next btn-style-none outline" alt="Go to next slide">' + arrow_right + '</button>'
			}

			_this.markup = _this.el.html();

			// accordion on mobile (bootstrap collapse)
			if ( Modernizr.mq("screen and (max-width:"+bp_cmsMobile+"px)")) {

				_this.addAccordionMarkup();

			    _this.container.addClass('initialized');
			    _this.container.find('.slider-loader').fadeOut();

			    // All IMAGES loaded when scrolling to section

			    // load image for opened sections
			    // var imgs = _this.container.find('.lazy-slide-bg');
			    // imgs.each(function(){
			    // 	_this.addImageSource($(this));
			    // })
			    // imgs.lazyload({
		     //        effect : "fadeIn",
		     //        load: function() {
		     //        	$(this).removeClass('loading');
		     //        }
		     //    });

			    // trigger scroll when opening section to load image
		        // _this.container.find('.collapse').on("shown.bs.collapse", function (e) {
		        // 	$(window).scroll();
		        // });

			} 
			// slider on desktop
			else {
			    _this.draw();
			}

		    // pause slider when hovering nav
		    // _this.navItems.on('mouseover',function(){
		    // 	_this.el.slick('pause');
		    // });
		    // _this.navItems.on('mouseout',function(){
		    // 	_this.el.slick('play');
		    // });

		    // on window resize destroy and stack...
		    $(window).smartresize(function () { 
		    	// Update to Accordion
		    	if ( Modernizr.mq("screen and (max-width:"+bp_cmsMobile+"px)")) {
					
					// return if already set up (on mobile resize in triggered on scroll)
					if ( _this.container.find('.panel-group').length > 0 ) { return; }

		    		// destroy slider
		    		_this.destroy();
					
					// init accordion
		    		_this.addAccordionMarkup();
		    		_this.container.addClass('initialized');
				    _this.container.find('.slider-loader').fadeOut();

				    _this.container.find('.lazy-slide-bg').lazyload({
			            effect : "fadeIn",
			            load: function() {
			            	$(this).removeClass('loading');
			            }
			        });
		    	} 
				// Update to Slider
		    	else if ( ! _this.initialized ) {
					_this.removeAccordionMarkup();
		    		_this.draw();
		    	}
		    })

		    return _this;
		}
	}

	return contentSlider.init(container);

}





// ========= AGENT SLIDER in navbar

var agentNavbarSlider_instances = [];

var initAgentNavbarSliders = function() {

	var agentNavbarSlider = $('#navbar .agent-slider-container');

	if ( agentNavbarSlider.length ) {
		agentNavbarSlider.each(function(){
			agentNavbarSlider_instances.push(initAgentNavbarSlider($(this)));
		})

	}
}
var destroyAgentNavbarSliders = function() {
	var instance;
	while (agentNavbarSlider_instances.length) {
		instance = agentNavbarSlider_instances.shift();
		instance.destroy();
	}
}

var initAgentNavbarSlider = function(container) {

	var agentNavbarSlider = {

		initialized: false,
		container: null,
		slider: null,
		options: {
			infinite: true,
			autoplay:false, // start when fixed nav displays
			fade: true,
			speed: 300,
			dots: false,
			arrows: false,
			// variableWidth: true,
			lazyLoad: 'ondemand',
			draggable: false,
			rows: 0
		},

		draw: function(){
			var _this = this;
			_this.el =  _this.slider.slick(_this.options);
		},

		destroy: function() {
			var _this = this;
			if ( !_this.el ) return;
			_this.el.slick('unslick');
			_this.initialized = false;
		},

		reset: function() {
			var _this = this;
			_this.destroy();
			_this.draw();
		},
		init: function(container) {
			var _this = this;

			if (container === undefined || container.length < 1) return;

			_this.container = container;
			// _this.options.autoplay = container.attr('data-autoplay');
			// _this.options.appendDots = container.find('.slider-dots');
			_this.slider = _this.container.find('.agent-slider');

			// === Events
		    _this.slider.on('init', function (slick) {

			    // _this.container.find('.slider-loader').fadeOut();
				_this.initialized = true;

				// content
				_this.slider.find('.slick-slide').addClass('hide-content');
				_this.slider.find('.slick-active').removeClass('hide-content');
		    });
			_this.slider.on('beforeChange', function(event, slick, currentSlide, nextSlide) {
				// hide content before transitioning
				_this.slider.find('.slick-slide').eq(currentSlide).addClass('hide-content');
			})
			_this.slider.on('afterChange', function(event, slick, currentSlide) {

				// show content
				_this.slider.find('.slick-slide').eq(currentSlide).removeClass('hide-content');
			})

			// === Resize Background
			// _this.resize();
			
		    // === Draw slider

			if ( !Modernizr.mq("screen and (max-width:"+bp_tablet_landscape+"px)")) { 
		    	_this.draw();
			}

		    $(window).smartresize(function () { 

		    	if ( ! _this.initialized ) {
		    		_this.draw();
		    	}
		    })

			return _this;
		}
	}

	return agentNavbarSlider.init(container);
	
}


// ========= AGENT SLIDER in popup

var agentPopupSlider_instances = [];

var initAgentPopupSliders = function() {

	var agentPopupSlider = $('#agent_modal .agent-slider-container');

	if ( agentPopupSlider.length ) {
		agentPopupSlider.each(function(){
			agentPopupSlider_instances.push(initAgentPopupSlider($(this)));
		})

	}
}
var destroyAgentPopupSliders = function() {
	var instance;
	while (agentPopupSlider_instances.length) {
		instance = agentPopupSlider_instances.shift();
		instance.destroy();
	}
}

var initAgentPopupSlider = function(container) {

	var agentPopupSlider = {

		initialized: false,
		container: null,
		slider: null,
		options: {
			infinite: true,
			autoplay:false, // start when fixed nav displays
			fade: true,
			speed: 300,
			dots: false,
			arrows: true,
			appendArrows: container.find('.slider-arrows'),
	        // prevArrow: '<button type="button" class="arrow-btn arrow-prev" aria-label="Previous"><i class="icon-arrow-left"></i></button>',
	        // nextArrow: '<button type="button" class="arrow-btn arrow-next" aria-label="Next"><i class="icon-arrow-right"></i></button>',
	        prevArrow: '<button type="button" class="arrow-btn arrow-prev" aria-label="Previous">'+arrow_left+'</button>',
	        nextArrow: '<button type="button" class="arrow-btn arrow-next" aria-label="Next">'+arrow_right+'</button>',
			lazyLoad: 'ondemand',
			draggable: false,
			rows: 0
		},

		draw: function(){
			var _this = this;
			_this.el =  _this.slider.slick(_this.options);
		},

		destroy: function() {
			var _this = this;
			if ( !_this.el ) return;
			_this.el.slick('unslick');
			_this.initialized = false;
			_this.container.addClass('loading');
		},

		reset: function() {
			var _this = this;
			_this.destroy();
			_this.draw();
		},
		init: function(container) {
			var _this = this;

			if (container === undefined || container.length < 1) return;

			_this.container = container;
			// _this.options.autoplay = container.attr('data-autoplay');
			// _this.options.appendDots = container.find('.slider-dots');
			_this.slider = _this.container.find('.agent-slider');

			// === Events
		    _this.slider.on('init', function (slick) {

			    _this.container.removeClass('loading');
				_this.initialized = true;

				// content
				_this.slider.find('.slick-slide').addClass('hide-content');
				_this.slider.find('.slick-active').removeClass('hide-content');
		    });
			_this.slider.on('beforeChange', function(event, slick, currentSlide, nextSlide) {
				// hide content before transitioning
				_this.slider.find('.slick-slide').eq(currentSlide).addClass('hide-content');


				// update form
				var thisNextSlide = _this.slider.find('.slick-slide').eq(nextSlide);

                var agentId = thisNextSlide.attr("data-agent-id");
                var agentName = thisNextSlide.attr("data-agent-name");
                var listingName = thisNextSlide.attr("data-name");
                var listingLocation = thisNextSlide.attr("data-location");


                // update hidden field with agent id
                $("#popup_enquire_agent_id").val(agentId);

                // update form heading
                $('#enquire_popup_heading').html(agentName);

                var subheading = '';
                if ( listingName ) {
                    subheading = listingName;
                } 
                if ( listingLocation ) {
                    subheading += ', ' + listingLocation;
                }
                $("#enquire_popup_subheading").html(subheading);
			})
			_this.slider.on('afterChange', function(event, slick, currentSlide) {

				var slide = _this.slider.find('.slick-slide').eq(currentSlide);

				// show content
				slide.removeClass('hide-content');


			})

			// === Resize Background
			// _this.resize();
			
		    // === Draw slider

			//if ( !Modernizr.mq("screen and (max-width:"+bp_tablet_landscape+"px)")) { 
		    	_this.draw();
			//}

		    $(window).smartresize(function () { 

		    	if ( ! _this.initialized ) {
		    		_this.draw();
		    	}
		    })

			return _this;
		}
	}

	return agentPopupSlider.init(container);
	
}




// ========= AGENT SLIDER in sidebar

var agentSlider_instances = [];

var initAgentSliders = function() {

	// var agentSlider = $('.listing-sidebar .agent-holder');
	var agentSlider = $('.listing-sidebar .agent-holder, .listing-enquiry-row .agent-holder');

	if ( agentSlider.length ) {
		agentSlider.each(function(){
			agentSlider_instances.push(initAgentSlider($(this)));
		})

	}
}
var destroyAgentSliders = function() {
	var instance;
	while (agentSlider_instances.length) {
		instance = agentSlider_instances.shift();
		instance.destroy();
	}
}

var initAgentSlider = function(container) {

	var agentSlider = {

		initialized: false,
		container: null,
		slider: null,
		options: {
		infinite: true,
		autoplay: false,
		fade: true,
		speed: 300,
		dots: false,
		arrows: true,
		appendArrows: container.find('.slider-arrows'),
        prevArrow: '<button type="button" class="arrow-btn arrow-prev" aria-label="Previous">'+arrow_left+'</button>',
        nextArrow: '<button type="button" class="arrow-btn arrow-next" aria-label="Next">'+arrow_right+'</button>',
		lazyLoad: 'ondemand',
		draggable: false,
		rows: 0
		},

		draw: function(){
			var _this = this;
			_this.el =  _this.slider.slick(_this.options);
		},

		destroy: function() {
			var _this = this;
			if ( !_this.el ) return;
			_this.el.slick('unslick');
			_this.initialized = false;
		},

		reset: function() {
			var _this = this;
			_this.destroy();
			_this.draw();
		},
		init: function(container) {
			var _this = this;

			if (container === undefined || container.length < 1) return;

			_this.container = container;
			// _this.options.autoplay = container.attr('data-autoplay');
			// _this.options.appendDots = container.find('.slider-dots');
			_this.slider = _this.container.find('.agent-slider');

			// === Events
		    _this.slider.on('init', function (slick) {

			    // _this.container.find('.slider-loader').fadeOut();
				_this.initialized = true;

				// content
				_this.slider.find('.slick-slide').addClass('hide-content');
				_this.slider.find('.slick-active').removeClass('hide-content');
		    });
			_this.slider.on('beforeChange', function(event, slick, currentSlide, nextSlide) {
				// hide content before transitioning
				_this.slider.find('.slick-slide').eq(currentSlide).addClass('hide-content');
			})
			_this.slider.on('afterChange', function(event, slick, currentSlide) {

				// show content
				_this.slider.find('.slick-slide').eq(currentSlide).removeClass('hide-content');
			})

			// === Resize Background
			// _this.resize();
			
		    // === Draw slider

			// if ( !Modernizr.mq("screen and (max-width:"+bp_tablet_landscape+"px)")) { 
		    	_this.draw();
			// }

		    $(window).smartresize(function () { 

		    	if ( ! _this.initialized ) {
		    		_this.draw();
		    	}
		    })

			return _this;
		}
	}

	return agentSlider.init(container);
	
}


// ========= LISTING SLIDER
// listing grid is a slider on large phone (<600px)

var listingSlider_instances = [];

var initListingSliders = function() {

	var listingSlider = $('.listing-grid-section.mobile-slider');

	if ( listingSlider.length ) {
		listingSlider.each(function(){
			listingSlider_instances.push(initListingSlider($(this)));
		})

	}
}
var destroyListingSliders = function() {
	var instance;
	while (listingSlider_instances.length) {
		instance = listingSlider_instances.shift();
		instance.destroy();
	}
}

var initListingSlider = function(container) {

	var listingSlider = {

		initialized: false,
		container: null,
		slider: null,
		options: {
		infinite: true,
		autoplay: false,
		// fade: true,
		speed: 300,
		dots: false,
		arrows: true,
		centerMode: true,
		centerPadding: '22.5px',
		slidesToShow: 1,
		// appendArrows: container.find('.arrow-wrapper'),
        // prevArrow: '<button type="button" class="arrow-btn arrow-prev" aria-label="Previous"><i class="icon-arrow-left"></i></button>',
        // nextArrow: '<button type="button" class="arrow-btn arrow-next" aria-label="Next"><i class="icon-arrow-right"></i></button>',
		appendArrows: container.find('.slider-arrows'),
        prevArrow: '<button type="button" class="arrow-btn arrow-prev btn-style-none" aria-label="Previous">'+arrow_left+'</button>',
        nextArrow: '<button type="button" class="arrow-btn arrow-next btn-style-none" aria-label="Next">'+arrow_right+'</button>',
		lazyLoad: 'ondemand',
		draggable: false,
		rows: 0
		},

		draw: function(){
			var _this = this;
			_this.el =  _this.slider.slick(_this.options);
		},

		destroy: function() {
			var _this = this;
			if ( !_this.el ) return;
			_this.el.slick('unslick');
			_this.initialized = false;
		},

		reset: function() {
			var _this = this;
			_this.destroy();
			_this.draw();
		},
		init: function(container) {
			var _this = this;

			if (container === undefined || container.length < 1) return;

			_this.container = container;
			// _this.options.autoplay = container.attr('data-autoplay');
			// _this.options.appendDots = container.find('.slider-dots');
			_this.slider = _this.container.find('.listing-grid');

			// === Events
		    _this.slider.on('init', function (slick) {

			    // _this.container.find('.slider-loader').fadeOut();
				_this.initialized = true;

				// content
				_this.slider.find('.slick-slide').addClass('hide-content');
				_this.slider.find('.slick-active').removeClass('hide-content');

				var currentIndex = _this.slider.find('.slick-current').index();
				_this.slider.find('.slick-slide').eq(currentIndex - 1).addClass('slick-left');
				_this.slider.find('.slick-slide').eq(currentIndex + 1).addClass('slick-right');

		    });
			_this.slider.on('beforeChange', function(event, slick, currentSlide, nextSlide) {
				// hide content before transitioning
				_this.slider.find('.slick-slide').eq(currentSlide).addClass('hide-content');
			})
			_this.slider.on('afterChange', function(event, slick, currentSlide) {

				var currentIndex = _this.slider.find('.slick-current').index();

				_this.slider.find('.slick-slide').removeClass('slick-left');
				_this.slider.find('.slick-slide').removeClass('slick-right');

				// show content
				_this.slider.find('.slick-slide').eq(currentIndex).removeClass('hide-content');

				// add class to previous and next slide
				_this.slider.find('.slick-slide').eq(currentIndex - 1).addClass('slick-left');
				_this.slider.find('.slick-slide').eq(currentIndex + 1).addClass('slick-right');

			})

			// === Resize Background
			// _this.resize();
			
		    // === Draw slider
			if ( Modernizr.mq("screen and (max-width:"+bp_large_phone+"px)")) { 
		    	_this.draw();
			}

		    $(window).smartresize(function () { 

		    	if ( Modernizr.mq("screen and (max-width:"+bp_large_phone+"px)")) {
			    	if ( ! _this.initialized ) {
			    		_this.draw();
			    	}
			    } else if ( _this.initialized ) {
			    	_this.destroy();
			    }
		    })

			return _this;
		}
	}

	return listingSlider.init(container);
	
}






// ======== LISTING HERO SLIDER

var listingHeroSlider_instances = [];

var initListingHeroSliders = function() {

	var listingHeroSlider = $('.listing-hero-slider-container');

	if ( listingHeroSlider.length ) {
		listingHeroSlider.each(function(){
			listingHeroSlider_instances.push(initListingHeroSlider($(this)));
		})

	}
}
var destroyListingHeroSliders = function() {
	var instance;
	while (listingHeroSlider_instances.length) {
		instance = listingHeroSlider_instances.shift();
		instance.destroy();
	}
}

var initListingHeroSlider = function(container) {

	var listingHeroSlider = {
		breakpoint: '1279px',
		initialized: false,
		container: null,
		slider: null,

		draw: function(){
			var _this = this;

			_this.container.addClass('init');

			_this.el = new Flickity('#listing-hero-slider', {
				cellAlign: 'left',
				freeScroll: true,
				prevNextButtons: false,
				pageDots: false,
				contain: true
				// setGallerySize: false
			});

			_this.initialized = true;

		},

		destroy: function() {
			var _this = this;
			if ( !_this.el ) return;

			_this.el.destroy();

			_this.container.removeClass('loading');
			_this.container.removeClass('init');
			_this.initialized = false;
		},

		resize: function() {
			var _this = this;
			if ( !_this.el ) return;

			_this.el.resize();
		},

		reset: function() {
			var _this = this;
			_this.destroy();
			_this.draw();
		},
		init: function(container) {
			var _this = this;

			if (container === undefined || container.length < 1) return;

			// === Variables
			_this.container = container;
			// _this.options.autoplay = _this.container.attr('data-autoplay');
			_this.slider = _this.container.find('.hero-slider');


			// ==== save markup before slick init
			// _this.slides = _this.slider.html();

			// === Draw slider
			//wait for all images to be loaded before draw 
			// _this.slider.find('img').load(function(){
			// 	_this.draw();
			// 	galleryModal.init();

			// 	_this.el.on( 'staticClick', function( event, pointer, cellElement, cellIndex ) {
			// 	  if ( $(event.target).is('img') || $(event.target).is('.overlay') || $(event.target).is('.play-icon') ) {
			// 	  	// fade in modal
			//     	galleryModal.show();
			//     	//happen gallery to modal and go to slide
			//     	galleryModal.showGallery(_this.slides, cellIndex, _this.slider);
			// 	  }
			// 	});
			// })

			//Draw slider once all images have loaded
			var loaded = 0;
			var imgs = _this.slider.find('img');

			imgs.each(function(){
				var img = $(this);
				if ( Modernizr.mq("screen and (max-width:" + bp_cmsMobile + "px)") ) {
					img.attr("data-lazy",  $(this).attr('data-mobileImage'));
				} 
				// Desktop image (992px + )
				else {
					img.attr("data-lazy",  $(this).attr('data-fullImage'));
				}
				img.attr("src", $(this).attr('data-lazy'));
			})

			imgs.one("load", function() {
				loaded++;
				// console.log($(this).attr('src') + ' loaded');
				if ( loaded < imgs.length ) { return; }
				// console.log('all loaded');

				_this.slides = _this.slider.html();

				_this.draw();
				galleryModal.init();

				_this.el.on( 'staticClick', function( event, pointer, cellElement, cellIndex ) {
				  if ( $(event.target).is('img') || $(event.target).is('.overlay') || $(event.target).is('.play-icon') ) {
				  	// fade in modal
			    	galleryModal.show();
			    	//happen gallery to modal and go to slide
			    	galleryModal.showGallery(_this.slides, cellIndex, _this.slider);
				  }
				});

			}).each(function() {
			  if(this.complete) $(this).load();
			});

			// ===== Draw slider once first image has loaded
			// var loaded = 0;
			// var allImgs = _this.slider.find('img');
			// var firstImg = allImgs.first();
			// var imgs = allImgs.not(':first');

			// // ==== Load first image and show slider

			// if ( Modernizr.mq("screen and (max-width:" + bp_cmsMobile + "px)") ) {
			// 	firstImg.attr("data-lazy",  firstImg.attr('data-mobileimage'));
			// } 
			// else {
			// 	firstImg.attr("data-lazy",  firstImg.attr('data-fullimage'));
			// }
			// firstImg.attr("src", firstImg.attr('data-lazy'));

			// firstImg.one("load", function() {
			// 	$(this).addClass('loaded');

			// 	_this.slides = _this.slider.html();

			// 	_this.draw();
			// 	galleryModal.init();

			// 	_this.el.on( 'staticClick', function( event, pointer, cellElement, cellIndex ) {
			// 	  if ( $(event.target).is('img') || $(event.target).is('.overlay') || $(event.target).is('.play-icon') ) {
			// 	  	// fade in modal
			//     	galleryModal.show();
			//     	//happen gallery to modal and go to slide
			//     	galleryModal.showGallery(_this.slides, cellIndex, _this.slider);
			// 	  }
			// 	});

			// }).each(function() {
			//   if(this.complete) $(this).load();
			// });

			// // ==== Load other images
			// imgs.each(function(){
			// 	var img = $(this);
			// 	if ( Modernizr.mq("screen and (max-width:" + bp_cmsMobile + "px)") ) {
			// 		img.attr("data-lazy",  $(this).attr('data-mobileImage'));
			// 	} 
			// 	// Desktop image (992px + )
			// 	else {
			// 		img.attr("data-lazy",  $(this).attr('data-fullImage'));
			// 	}
			// 	img.attr("src", $(this).attr('data-lazy'));
			// })

			// imgs.one("load", function() {
			// 	loaded++;
			// 	_this.resize();
			// 	var img = $(this);
			// 	setTimeout(function(){img.addClass('loaded')},1000);
			// 	if ( loaded < imgs.length ) { return; }
			// 	// all loaded

			// }).each(function() {
			//   if(this.complete) $(this).load();
			// });



			// _this.draw();

		    // galleryModal.init();

		    // use Flickity static click
		    // because standard jquery click is triggered on drag
			// _this.el.on( 'staticClick', function( event, pointer, cellElement, cellIndex ) {
			//   if ( $(event.target).is('img') || $(event.target).is('.overlay') || $(event.target).is('.play-icon') ) {
			//   	// fade in modal
		 //    	galleryModal.show();
		 //    	//happen gallery to modal and go to slide
		 //    	galleryModal.showGallery(_this.slides, cellIndex, _this.slider);
			//   }
			// });

			return _this;
		}
	}

	return listingHeroSlider.init(container);
	
}

// ======== GALLERY (Content module)


// ======== HERO SLIDER

var gallery_instances = [];

var initGalleries = function() {

	var gallery = $('.gallery-container');

	if ( gallery.length ) {
		gallery.each(function(){
			gallery_instances.push(initGallery($(this)));
		})

	}
}
var destroyGalleries = function() {
	var instance;
	while (gallery_instances.length) {
		instance = gallery_instances.shift();
		instance.destroy();
	}
}

var initGallery = function(container) {

	var gallery = {
		breakpoint: '1279px',
		initialized: false,
		container: null,
		slider: null,
		isPaused: true,
		percentTime: 0,
		tick: 0,
		speed: 3,
		options: {
			slidesToShow: 1,
			dots: false,
			fade: true,
			lazyLoad: "progressive", //loads the visible slides on init, and then progressively loads the rest of the slides on window.load()
			// lazyLoad: "ondemand", // loads slides on demand. When a slide becomes visible (or on the before slide callback) the load is fired.
			arrows: true,
			prevArrow: '<button type="button" class="slider-prev btn-style-none" alt="Previous Slide">'+arrow_left+'</button>',
			nextArrow: '<button type="button" class="slider-next white btn-style-none" alt="Next Slide">'+arrow_right+'</button>',
			draggable: true,
			rows: 0,
			responsive: [
				{
					breakpoint: 1024,
					settings: {
						draggable: true,
					}
				}
			]
		},

		draw: function(){
			var _this = this;
			_this.el =  _this.slider.slick(_this.options);
		},

		destroy: function() {
			var _this = this;
			if ( !_this.el ) return;
			_this.el.slick('unslick');
			_this.container.removeClass('loading');
			_this.initialized = false;
		},
		updateNumber: function(slide) {

			var _this = this;

			var slideCount = _this.container.find('.slick-slide:not(.slick-cloned)').length;

			// x of x 
			if ( _this.container.find('.slider-count').length ) {
				_this.container.find('.current').html(('0' + (slide+1)).slice(-2));
				_this.container.find('.total').html(('0' + slideCount).slice(-2));
			}
		},

		startProgressBar: function() {
			var _this = this;

			_this.resetProgressBar();

		    _this.percentTime = 0;
		    _this.isPaused = false;
		    
		    _this.tick = setInterval(function(){
		    	if(_this.isPaused === false) {
			      	_this.percentTime += 1 / (_this.speed+0.2);

			      	if ( Modernizr.mq("screen and (max-width:"+bp_tablet_landscape+"px)")) {
				      	_this.progressBar.css('width', _this.percentTime+"%");
			      	} else {
				      	_this.progressBar.css('height', _this.percentTime+"%");
			      	}

			      	if(_this.percentTime >= 100) {
			          	_this.el.slick('slickNext');
			          	_this.startProgressBar();
			        }
			    }
		    }, 10);

		},

		resetProgressBar: function() {
			var _this = this;
			if ( Modernizr.mq("screen and (max-width:"+bp_tablet_landscape+"px)")) {
				_this.progressBar.css('width', 0+'%');
			} else {
				_this.progressBar.css('height', 0+'%');
			}
		    
		    clearTimeout(_this.tick);
		},

		reset: function() {
			var _this = this;
			_this.destroy();
			_this.draw();
		},
		addImgSource: function(img) {
			var _this = this;

			// Mobile Image ( - 991px )
			if ( Modernizr.mq("screen and (max-width:" + bp_cmsMobile + "px)") ) {
				img.each(function () {
					$(this).attr("data-lazy",  $(this).attr('data-mobileImage'));
				});
			} 
			// Desktop image (992px + )
			else {
				img.each(function () {
					$(this).attr("data-lazy",  $(this).attr('data-fullImage'));
				});
			}
		},
		init: function(container) {
			var _this = this;

			if (container === undefined || container.length < 1) return;

			// === Variables
			_this.container = container;
			_this.options.autoplay = _this.container.attr('data-autoplay');
			_this.options.appendArrows = _this.container.find('.arrows-container');
			_this.slider = _this.container.find('.gallery');

			_this.progressBarContainer = _this.container.find('.slide-progress');
			_this.progressBar = _this.container.find('.slide-progress .progress');

			_this.addImgSource(_this.slider.find('img'));


			// === Events
		    _this.slider.on('init', function (slick) {
			    _this.container.find('.slider-loader').fadeOut();
			    _this.container.removeClass('loading');
				_this.initialized = true;

				_this.updateNumber(0);

				_this.startProgressBar();
		    });
			_this.slider.on('beforeChange', function(event, slick, currentSlide, nextSlide) {
				// give label to first slide
				_this.updateNumber(nextSlide);
			})
			_this.slider.on('afterChange', function(event, slick, currentSlide) {
			})


			// Slick azy load doesnt work on background image but there is an <img /> in gallery that is used in modal
			// When <img /> is loaded set background image on parent
			_this.slider.on('lazyLoaded', function(event, slick, image, imageSource){
			  $(image).parent('.inner').css('background-image', 'url("'+imageSource+'")');
			});

			_this.container.on({
			// _this.slider.on({
			    mouseenter: function() {
			      _this.isPaused = true;
			    },
			    mouseleave: function() {
			      _this.isPaused = false;
			    }
			})


			// ==== save markup before slick init
			slidesHtml = _this.slider.html();

			// make "data-lazy" img "src"
			_this.slides = slidesHtml.replace(/data-lazy/g, 'src');

			// === Draw slider
			_this.draw();

		    galleryModal.init();
		    var slide = _this.slider.find('.item');

		    // on click on slide
		    slide.on('click', function(){

		    	_this.resetProgressBar();
		    	//fade in modal
		    	galleryModal.show();

		    	// manually load images for thumbs
				// _this.slider.find('img').load();


		    	//happen gallery to modal and go to slide
		    	galleryModal.showGallery(_this.slides, $(this).index(), _this.slider, _this);
		    })


		 	// Draw slider once first image has loaded
			// var imgs = _this.slider.find('img');

			// var img = $(imgs[0]);

			// // img.attr("src", img.attr('data-lazy'));

			// img.on("load", function() {

			// 	var slidesHtml = _this.slider.html();

			// 	// remove "data-lazy" from img
			// 	_this.slides = slidesHtml.replace(/data-lazy/g, 'src');

			// 	// === Draw slider
			// 	_this.draw();

			//     galleryModal.init();
			//     var slide = _this.slider.find('.item');

			//     // on click on slide
			//     slide.on('click', function(){

			//     	_this.resetProgressBar();
			//     	//fade in modal
			//     	galleryModal.show();

			//     	// manually load images for thumbs
			// 		// _this.slider.find('img').load();


			//     	//happen gallery to modal and go to slide
			//     	galleryModal.showGallery(_this.slides, $(this).index(), _this.slider, _this);
			//     })

			// });

			return _this;
		}
	}

	return gallery.init(container);
	
}



// ======== GALLERY MODAL

var galleryModal = {

	show: function() {
		$('#gallery_modal').modal('show');
		// $('#gallery_modal').addClass('on');
		// $('body').addClass('no-scroll');
	},
	hide: function() {
		var _this = this;
		$('#gallery_modal').modal('hide');
		// $('#gallery_modal').removeClass('on');
		// $('body').removeClass('no-scroll');

		// destroy 
		_this.destroy();
	},
	goTo: function(slider, index) {
		var _this = this;
		var currentSlide = slider.slick('slickCurrentSlide');
		
		slider.slick('slickGoTo',index);

		slider.css('opacity', 1);
	},
	setLabel: function(slide) {

		var _this = this;

		var countContainer = _this.galleryThumbsContainer.siblings('.count-container').find('.slide-count');

		var slideCount = _this.galleryThumbsContainer.find('.slick-slide:not(.slick-cloned)').length;

		// x of x 
		if ( countContainer.length ) {
			countContainer.find('.active').html(('0' + (slide+1)).slice(-2));
			countContainer.find('.total').html(('0' + slideCount).slice(-2));
		}
	},
	showGallery: function(slides, slide, navFor, sliderObject){
		var _this = this;

		_this.sliderObject = sliderObject || null;

		_this.heroGallery = navFor;

		_this.createGallery(slides, slide, navFor);
	},
	createIframe: function(slide){
		slide.find('.inner').html('<div class="video-container"></div>');
		var container = slide.find('.video-container');
		var url = slide.attr('data-video-src');
     	var iframeW = slide.attr('data-width') == '' ? '560' : slide.attr('data-width');
      	var iframeH = slide.attr('data-height') == '' ? '315' : slide.attr('data-height');
		
		// create iframe
		var iframe = '<iframe class="is-hidden" width="'+iframeW+'" height="'+iframeH+'" src="' + url + '" frameborder="0"></iframe>';
        container.append(iframe);
        iframe = container.find('iframe');
        iframe.attr('data-src',url);
		
		// resize
        resizeIframe(iframe);
        
	},
	playIframe: function(slide) {
		var iframe = slide.find('iframe');
		if ( iframe.length < 1 ) { return; }
		var url = iframe.attr('data-src');

		if ( ('youtube').indexOf(url) ) {
          var sign = url.toLowerCase().indexOf("?") >= 0 ? '&' : '?';
          var iframe_src = url + sign + "autoplay=1";
        } else if ( ('vimeo').indexOf(url) ) {
          var sign = url.toLowerCase().indexOf("?") >= 0 ? '&' : '?';
          var iframe_src = url + sign + "autoplay=1";
        }
        iframe.attr('src',iframe_src);
	},
	stopIframe: function(slide) {
		var iframe = slide.find('iframe');
		iframe.attr('src',iframe.attr('data-src'));
	},
	createGallery: function(slides, slide_index, navFor){
		var _this  = this;
		// append slides
		// slides.removeClass().data('autoplay',false).addClass('gallery');
		_this.galleryContainer.append('<div class="gallery">' + slides + '</div>');

		// video iframe.
		_this.galleryContainer.find('.item.video').each(function() {
			_this.createIframe($(this));
		})


		// if less than 4 slides, hide thumbnails
		var count = (slides.match(/<div class="item/g) || []).length;
		var thumbsClass = count < 3 ? 'hidden' : '';

		// thumbs
		_this.galleryThumbsContainer.append('<div class="gallery_thumbs '+thumbsClass+'">' + slides + '</div>');
		_this.gallery = _this.galleryContainer.find('.gallery');
		_this.thumbs = _this.galleryThumbsContainer.find('.gallery_thumbs');

		// events
	    _this.gallery.on('init', function (slick) {
		    _this.el.find('.slider-loader').fadeOut();
	    });

		// draw slider
		_this.gallery.slick({
			slidesToShow: 1,
			slidesToScroll: 1,
			autoplay: false,
			dots: false,
			arrows: false,
			lazyLoad: 'ondemand',
			fade: true,
			asNavFor: _this.thumbs,
			rows: 0
		});
		// events
	    _this.thumbs.on('init', function (slick) {
		    _this.el.find('.slider-loader').fadeOut();
			_this.setLabel(0);
	    });
		_this.gallery.on('beforeChange', function(event, slick, currentSlide, nextSlide) {

			var prevSlide = _this.gallery.find('.slick-slide:not(.slick-cloned)').eq(currentSlide);
			var nextSlide = _this.gallery.find('.slick-slide:not(.slick-cloned)').eq(nextSlide);
			
			// pause previous video
			if (prevSlide.hasClass('video')) {
			_this.stopIframe(prevSlide);
			}
			// play next video
			if (nextSlide.hasClass('video')) {
				_this.playIframe(nextSlide);
			}
		})
		_this.thumbs.on('beforeChange', function(event, slick, currentSlide, nextSlide) {
			// give label to first slide
			_this.setLabel(nextSlide);
		})
		_this.thumbs.on('afterChange', function(event, slick, currentSlide) {
			// move slide in gallery (out of modal) if is slick slider
			if ( _this.heroGallery && _this.heroGallery.hasClass('slick-initialized')) {
				_this.heroGallery.slick('slickGoTo',currentSlide);
			}
		})

		var width_item, padding, paddings, nbSlidesToShow, nbSlidesToShowTablet, thumbsContainerWidth;

		// // On Load
		// calculateThumbsVariables();
		// _this.galleryThumbsContainer.css('width', thumbsContainerWidth);
		// _this.galleryArrowsContainer.css('width', thumbsContainerWidth);

	 //  	//on window resize destroy and stack...
	 //    $(window).smartresize(function () { 
	 //    	calculateThumbsVariables();
		// 	_this.galleryThumbsContainer.css('width', thumbsContainerWidth);
		// 	_this.galleryArrowsContainer.css('width', thumbsContainerWidth);
	 //    })

		// draw slider
		_this.thumbs.slick({
			// slidesToShow: nbSlidesToShow,
			focusOnSelect: true,
			slidesToScroll: 1,
			autoplay: false,
			dots: false,
			arrows: true,
			variableWidth: true,
			lazyLoad: 'progressive',
			centerMode: true,
			centerPadding: '0', // no slide visible on the side
			rows: 0,
			asNavFor: _this.gallery,
			appendArrows: _this.galleryThumbsContainer.parents().find('#slider-modal-arrows'),
		    prevArrow: '<button type="button" class="slider-prev btn-style-none" alt="Go to previous slide">' + arrow_left + '</button>',
		    nextArrow: '<button type="button" class="slider-next btn-style-none" alt="Go to next slide">' + arrow_right + '</button>',	
  			responsive: [
		    {
		      breakpoint: 1199,
		      settings: {
		        // slidesToShow: nbSlidesToShowTablet
		      }
		    }
		    ]
		});
		
		_this.goTo(_this.gallery, slide_index);

	},
	destroy: function() {
		var _this = this;
		if ( _this.gallery ) {
			_this.gallery.slick('unslick');
			_this.gallery.remove();
		}
		if ( _this.thumbs ) {
			_this.thumbs.slick('unslick');
			_this.thumbs.remove();
		}
		if ( _this.closeEl) {
			_this.closeEl.css('display','block');
		}

	},
	init: function() {
		var _this = this;

		_this.el = $('#gallery_modal');	
		_this.closeEl = $('#close_gallery');
		_this.galleryContainer = _this.el.find('.gallery_container');
		_this.galleryThumbsContainer = _this.el.find('.gallery_thumbs_container');
		_this.galleryArrowsContainer = _this.el.find('#slider-modal-arrows');

		_this.closeEl.on('click',function(){
			_this.hide();
		})

		_this.el.on('click',function(e){
			// if click on overlay, hide modal
			if ( $(e.target).hasClass('img')) {
				_this.hide();
			}
		})

		$('#gallery_modal').on('show.bs.modal', function() {
			$('body').addClass('no-scroll');
		})
		$('#gallery_modal').on('shown.bs.modal', function() {
			setTimeout(function(){
				$('#gallery_modal').addClass('shown');
			}, 100)
			// setTimeout(function(){
			// 	$('#gallery_modal').addClass('shown');
			// }, 00)
		})
		$('#gallery_modal').on('hide.bs.modal', function() {
			$('#gallery_modal').removeClass('shown');
			
			// start progress bar if slider has one (out of modal)
			if ( _this.sliderObject && _this.sliderObject.hasOwnProperty('startProgressBar') ) {
				_this.sliderObject.startProgressBar();
			}

			_this.destroy();

		})
		$('#gallery_modal').on('hidden.bs.modal', function() {
			$('body').removeClass('no-scroll');
		})


	}
}



// ========= Home banner: statements slider

var homeStatementSlider_instances = [];

var initHomeStatementSliders = function() {

	var homeStatementSlider = $('.home-hero-banner');

	if ( homeStatementSlider.length ) {
		homeStatementSlider.each(function(){
			homeStatementSlider_instances.push(initHomeStatementSlider($(this)));
		})

	}
}
var destroyHomeStatementSliders = function() {
	var instance;
	while (homeStatementSlider_instances.length) {
		instance = homeStatementSlider_instances.shift();
		instance.destroy();
	}
}

var initHomeStatementSlider = function(container) {

	var homeStatementSlider = {

		initialized: false,
		container: null,
		slider: null,
		options: {
			infinite: true,
			autoplay:false, // start with home animation
			// autoplay:true,
			fade: true,
			speed: 300,
			dots: false,
			arrows: false,
			// variableWidth: true,
			// lazyLoad: 'ondemand',
			draggable: false,
			pauseOnHover: false,
			rows: 0
		},

		draw: function(){
			var _this = this;
			_this.el =  _this.slider.slick(_this.options);
		},

		destroy: function() {
			var _this = this;
			if ( !_this.el ) return;
			_this.el.slick('unslick');
			_this.initialized = false;
		},

		reset: function() {
			var _this = this;
			_this.destroy();
			_this.draw();
		},
		init: function(container) {
			var _this = this;

			if (container === undefined || container.length < 1) return;

			_this.container = container;
			// _this.options.autoplay = container.attr('data-autoplay');
			// _this.options.appendDots = container.find('.slider-dots');
			_this.slider = _this.container.find('.statement-slider');

			// === Events
		    _this.slider.on('init', function (slick) {

			    // _this.container.find('.slider-loader').fadeOut();
				_this.initialized = true;

				// content
				_this.slider.find('.slick-slide').addClass('hide-content');
				_this.slider.find('.slick-active').removeClass('hide-content');
				_this.container.removeClass('loading');
		    });
			_this.slider.on('beforeChange', function(event, slick, currentSlide, nextSlide) {
				// hide content before transitioning
				_this.slider.find('.slick-slide').eq(currentSlide).addClass('hide-content');
			})
			_this.slider.on('afterChange', function(event, slick, currentSlide) {

				// show content
				_this.slider.find('.slick-slide').eq(currentSlide).removeClass('hide-content');
			})

			// === Resize Background
			// _this.resize();
			
		    // === Draw slider

			// if ( !Modernizr.mq("screen and (max-width:"+bp_tablet_landscape+"px)")) { 
		 //    	_this.draw();
			// }

			_this.draw();

		    $(window).smartresize(function () { 

		    	if ( ! _this.initialized ) {
		    		_this.draw();
		    	}
		    })

			return _this;
		}
	}

	return homeStatementSlider.init(container);
	
}




// ========= Featured Projects

var featuredProjectsSlider_instances = [];

var initFeaturedProjectsSliders = function() {

	var featuredProjectsSlider = $('.featured-projects-section');

	if ( featuredProjectsSlider.length ) {
		featuredProjectsSlider.each(function(){
			featuredProjectsSlider_instances.push(initFeaturedProjectsSlider($(this)));
		})

	}
}
var destroyFeaturedProjectsSliders = function() {
	var instance;
	while (featuredProjectsSlider_instances.length) {
		instance = featuredProjectsSlider_instances.shift();
		instance.destroy();
	}
}

var initFeaturedProjectsSlider = function(container) {

	var featuredProjectsSlider = {

		initialized: false,
		container: null,
		slider: null,
		options: {
			// infinite: true,
			// autoplay:false, // start when fixed nav displays
			centerMode: true,
			// centerPadding: '90px', // space on the side
			// slidesToShow: 1,
			autoplay:false,
			fade: false,
			speed: 600,
			dots: false,
			arrows: true,
			lazyload: 'ondemand',
			accessibility: false,
			infinite: true,
			appendArrows: container.find('.arrows-container'),
			prevArrow: '<button type="button" class="slider-prev btn-style-none" alt="Previous Slide">'+arrow_left+'</button>',
			nextArrow: '<button type="button" class="slider-next btn-style-none" alt="Next Slide">'+arrow_right+'</button>',
			draggable: true,
			rows: 0
		},

		draw: function(){
			var _this = this;
			if ( _this.initialized ) { return; }
			_this.el =  _this.slider.slick(_this.options);
		},

		destroy: function() {
			var _this = this;
			if ( !_this.el ) return;
			_this.el.slick('unslick');
			_this.initialized = false;

			_this.slider.find('.item').off('click');
		},

		reset: function() {
			var _this = this;
			_this.destroy();
			_this.draw();
		},

		updateCount: function(index) {
			var _this = this;

			var i = ('0' + (index+1)).slice(-2);

			_this.container.find('.slider-count .current').html(i);

		},

		updateResponsiveLayout: function() {
			var _this = this;
			// update markup on mobile to have one project per slider
			if ( Modernizr.mq("screen and (max-width:"+bp_cmsMobile+"px)") && !_this.slider.hasClass('mobile-layout') ) {
		    	if ( _this.initialized ) {
		    		var slideCount = _this.container.find('.slick-slide:not(.slick-cloned)').find('.item').length;
		    	} else {
		    		var slideCount = _this.container.find('.slide .item').length;
		    	}
				updateLayout(_this.markupMobile, slideCount);
				_this.slider.addClass('mobile-layout');
			}
			// default (if going from mobile to desktop) 
			else if (!Modernizr.mq("screen and (max-width:"+bp_cmsMobile+"px)") && _this.slider.hasClass('mobile-layout')) {
		    	if ( _this.initialized ) {
		    		var itemCount = _this.container.find('.slick-slide:not(.slick-cloned)').length;
		    		var slideCount = Math.floor(itemCount / 2) ;
		    	} else {
		    		var slideCount = _this.container.find('.slide').length;
		    	}
				updateLayout(_this.markupDefault, slideCount);
				_this.slider.removeClass('mobile-layout');
			}

			function updateLayout(markup, slideCount) {
				// fade out slider

				// detroy slider
				_this.destroy();
				// update markup
				_this.slider.html(markup);
				// draw slider
				if ( !_this.initialized ) {
		    		_this.draw();
		    	}
		    	_this.container.find('.slider-count').find('.total').html(('0' + slideCount).slice(-2));
			}
		},

		init: function(container) {
			var _this = this;

			if (container === undefined || container.length < 1) return;

			_this.container = container;
			// _this.options.autoplay = container.attr('data-autoplay');
			// _this.options.appendDots = container.find('.slider-dots');
			_this.slider = _this.container.find('.slider');

			// === Events
		    _this.slider.on('init', function (slick) {

			    // _this.container.find('.slider-loader').fadeOut();
				_this.initialized = true;

				// content
				_this.container.removeClass('loading');

				_this.slider.find('.slick-slide').addClass('has-light-overlay');
				_this.slider.find('.slick-active').removeClass('has-light-overlay');

				_this.slider.find('.slick-current').find('.item-link').removeClass('no-smoothstate');



		    });
			_this.slider.on('beforeChange', function(event, slick, currentSlide, nextSlide) {
				
				// update count
				_this.updateCount(nextSlide);
				
				// no item clickable
				_this.slider.find('.slick-slide .item-link').addClass('no-smoothstate');
			})


			_this.slider.on('afterChange', function(event, slick, currentSlide) {

				// overlay
				_this.slider.find('.slick-slide').addClass('has-light-overlay');
				// _this.slider.find('.slick-slide').eq(currentSlide).removeClass('has-light-overlay');
				_this.slider.find('.slick-slide[data-slick-index="'+currentSlide+'"]').removeClass('has-light-overlay');
				
				// update "no-smoothstate" class

				// _this.slider.find('.slick-slide .item-link').addClass('no-smoothstate');
				// _this.slider.find('.slick-slide .item-link').addClass('no-smoothstate');
				// _this.slider.find('.slick-slide').eq(currentSlide).find('.item-link').removeClass('no-smoothstate');
				_this.slider.find('.slick-slide[data-slick-index="'+currentSlide+'"]').find('.item-link').removeClass('no-smoothstate');

			})

			_this.slider.find('.item').on('click', function(e){
				e.preventDefault();

				if ( !$(this).find('.item-link').hasClass('no-smoothstate') ) { return; }

				var slide = $(this).parents('.slick-slide');
				var slide_index = slide.attr('data-slick-index');

				_this.slider.slick('goTo', slide_index);

			})


			_this.slider.on('lazyLoaded', function(event, slick, image, imageSource){
			  $(image).parent('.bg-img').css('background-image', 'url("'+imageSource+'")');
			});

			// === Resize Background
			// _this.resize();
			
		    // === Draw slider

			// if ( !Modernizr.mq("screen and (max-width:"+bp_tablet_landscape+"px)")) { 
		 //    	_this.draw();
			// }

			// Save default markup and set mobile markup.
			_this.markupDefault = _this.slider.html();

			_this.markupMobile = '';
			var items = _this.slider.find('.item');
			for ( var i = 0; i < items.length; i++) {
				var inner = $(items[i]).html();
				_this.markupMobile += '<div class="slide"><div class="item featured-card">' + inner + '</div></div>';
			}


			_this.updateResponsiveLayout();

			if ( ! _this.initialized ) {
	    		_this.draw();
	    	}

		    $(window).smartresize(function () { 

		    	_this.updateResponsiveLayout();

		    	if ( ! _this.initialized ) {
		    		_this.draw();
		    	}
		    })

			return _this;
		}
	}

	return featuredProjectsSlider.init(container);
	
}








// ========= Home banner: statements slider

var logoSlider_instances = [];

var initLogoSliders = function() {

	var logoSlider = $('.logo-slider');

	if ( logoSlider.length ) {
		logoSlider.each(function(){
			logoSlider_instances.push(initLogoSlider($(this)));
		})

	}
}
var destroyLogoSliders = function() {
	var instance;
	while (logoSlider_instances.length) {
		instance = logoSlider_instances.shift();
		instance.destroy();
	}
}

var initLogoSlider = function(container) {

	var logoSlider = {

		initialized: false,
		container: null,
		slider: null,
		
		updateCount: function(index) {
			var _this = this;

			var i = ('0' + (index+1)).slice(-2);

			_this.container.find('.slider-pagination-count .current').html(i);

		},

		addImgSource: function(img) {
			var _this = this;

			// Mobile Image ( - 991px )
			if ( Modernizr.mq("screen and (max-width:" + bp_cmsMobile + "px)") ) {
				img.each(function () {
					$(this).attr("data-lazy",  $(this).attr('data-mobileImage'));
				});
			} 
			// Desktop image (992px + )
			else {
				img.each(function () {
					$(this).attr("data-lazy",  $(this).attr('data-fullImage'));
				});
			}
		},

		draw: function(){
			var _this = this;
			if ( _this.initialized ) { return; }
			_this.el =  _this.slider.slick(_this.options);
		},

		destroy: function() {
			var _this = this;
			if ( !_this.el ) return;
			_this.el.slick('unslick');
			_this.initialized = false;
		},

		reset: function() {
			var _this = this;
			_this.destroy();
			_this.draw();
		},
		// Mobile/Desktop
		updateMarkup: function() {
			var _this = this;
			// update markup on mobile to have 4 items per slide
			if ( Modernizr.mq("screen and (max-width:"+bp_tablet_portrait+"px)") && !_this.slider.hasClass('mobile-layout') ) {
				updateWithMarkup(_this.markupMobile);
				_this.slider.addClass('mobile-layout');
			}
			// default (if going from mobile to desktop) 
			else if (!Modernizr.mq("screen and (max-width:"+bp_tablet_portrait+"px)") && _this.slider.hasClass('mobile-layout')) {
				updateWithMarkup(_this.markupDefault);
				_this.slider.removeClass('mobile-layout');
			}

			function updateWithMarkup(markup) {
				// detroy slider
				_this.destroy();
				// update markup
				_this.slider.html(markup);
				// draw slider
				if ( !_this.initialized ) {
		    		_this.draw();
		    	}
		    	// update count
		    	var slideCount = _this.container.find('.slick-slide:not(.slick-cloned)').length;
		    	_this.container.find('.count').find('.total').html(('0' + slideCount).slice(-2));
			}
		},
		init: function(container) {
			var _this = this;

			if (container === undefined || container.length < 1) return;

			_this.container = container;
			// _this.options.autoplay = container.attr('data-autoplay');
			// _this.options.appendDots = container.find('.slider-dots');
			_this.slider = _this.container.find('.slider');

			// replace img source
			// _this.addImgSource(_this.slider.find("img"));

			_this.options = {
				infinite: true,
				autoplay:false, // start when scroll to it
				fade: true,
				autoplaySpeed: 3000,
				speed: 600,
				dots: false,
			    appendArrows: _this.container.find('.slider-arrows'),
			    prevArrow: '<button type="button" class="slider-prev btn-style-none outline" alt="Go to previous slide">' + arrow_left + '</button>',
			    nextArrow: '<button type="button" class="slider-next btn-style-none outline" alt="Go to next slide">' + arrow_right + '</button>',
				draggable: false,
				// pauseOnHover: false, // will be set when autoplay starts
				pauseOnHover: true, // will be set when autoplay starts
				rows: 0
			};

			// === Events
		    _this.slider.on('init', function (slick) {

			    // _this.container.find('.slider-loader').fadeOut();
				_this.initialized = true;

				// content
				_this.slider.find('.slick-slide').addClass('hide-content');
				_this.slider.find('.slick-active').removeClass('hide-content');
				_this.container.removeClass('loading');
		    });
			_this.slider.on('beforeChange', function(event, slick, currentSlide, nextSlide) {
				// hide content before transitioning
				_this.slider.find('.slick-slide').eq(currentSlide).addClass('hide-content');
				_this.updateCount(nextSlide);
			})
			_this.slider.on('afterChange', function(event, slick, currentSlide) {
				// after plays (false by default);
				_this.slider.slick('setOption', 'pauseOnHover', true);

				// show content
				_this.slider.find('.slick-slide').eq(currentSlide).removeClass('hide-content');
			})

			// === Resize Background
			// _this.resize();
			
		    // === Draw slider

			// if ( !Modernizr.mq("screen and (max-width:"+bp_tablet_landscape+"px)")) { 
		 //    	_this.draw();
			// }

			// _this.draw();


			// Save default markup and set mobile markup.
			_this.markupDefault = _this.slider.html();

			_this.markupMobile = '';
			var items = _this.slider.find('.item');
			for ( var i = 0; i < items.length; i++) {
				var itemsPerSlide = 8;
				// var inner = $(items[i]).html();
				// copy item.
				var item = $('<div>').append($(items[i]).clone()).html();

				var count = i+1;

				// open slide
				if ( count % itemsPerSlide == 1 ) { 
	                _this.markupMobile += '<div class="slide"><div class="slide-flex">'; 
	            }
	            // item
				_this.markupMobile += item;
				// close slide
				if ( count % itemsPerSlide == 0 || count == items.length ) { 
	                _this.markupMobile += '</div></div>'; 
	            }
			}

			_this.updateMarkup();

			if ( ! _this.initialized ) {
	    		_this.draw();
	    	}

	    	//for stacker layout: redraw when open collapsed section
	    	$('.stacker-section').on("shown.bs.collapse", function (e) {
				if (!_this.initialized) {
				    _this.draw();
				} else {
				    _this.reset();
				}
		    });

		    $(window).smartresize(function () { 

		    	_this.updateMarkup();

		    	if ( ! _this.initialized ) {
		    		_this.draw();
		    	}
		    })

			return _this;
		}
	}

	return logoSlider.init(container);
	
}
